import { render, staticRenderFns } from "./PageMediaLibrary.vue?vue&type=template&id=af8061b2&"
import script from "./PageMediaLibrary.vue?vue&type=script&lang=js&"
export * from "./PageMediaLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af8061b2')) {
      api.createRecord('af8061b2', component.options)
    } else {
      api.reload('af8061b2', component.options)
    }
    module.hot.accept("./PageMediaLibrary.vue?vue&type=template&id=af8061b2&", function () {
      api.rerender('af8061b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/media-library/PageMediaLibrary.vue"
export default component.exports